{
  "english": "EN",
  "german": "DE",
  "guide": "Guide",
  "guideTitle": "Open DMW's help",
  "language": "Language",
  "theme": "Theme",
  "themeDark": "Dark",
  "themeLight": "Light",
  "themeNeon": "Neon",
  "themeRetro": "Retro",
  "title": "DMW",
  "toHome": "Go to Documents",
  "toLanding": "Back to start page",
  "toLogin": "Sign in"
}
